import { CheckCircleIcon, HourglassIcon, XCircleIcon } from 'lucide-react';
import React from 'react';

import { cn } from '@/utils/classname';

export interface HealthStatusIconProps {
  status: 'success' | 'error' | 'unknown';
}

/**
 * Badge-style status indicator for health checks
 *
 * Replaces corner icon badges with horizontal badge pattern
 * matching Settings page style. Provides icon + label + color
 * for accessibility.
 */
export const HealthStatusIcon: React.FC<HealthStatusIconProps> = ({
  status,
}) => {
  const config = {
    success: {
      icon: CheckCircleIcon,
      label: 'Healthy',
      className: 'bg-green-500/10 text-green-600 ring-green-500/20',
    },
    error: {
      icon: XCircleIcon,
      label: 'Issue',
      className: 'bg-red-500/10 text-red-600 ring-red-500/20',
    },
    unknown: {
      icon: HourglassIcon,
      label: 'Unknown',
      className: 'bg-gray-500/10 text-gray-500 ring-gray-500/20',
    },
  }[status];

  const Icon = config.icon;

  return (
    <div
      className={cn(
        'flex items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-medium ring-1',
        config.className
      )}
      data-testid={`health-status-${status}`}
    >
      <Icon className="size-3.5" />
      <span>{config.label}</span>
    </div>
  );
};
